import { createContext } from 'react';
const ModalQueueContext = createContext();
export default ModalQueueContext;
